if (!customElements.get('marquee-ticker')) {
  customElements.define(
    'marquee-ticker',
    class MarqueeTicker extends HTMLElement {
      connectedCallback() {
        this.copy = this.querySelector('.custom-marquee__copy');
        if (!this.copy) return;

        this.updateDuration();

        /* Text width changes with the viewport and again when webfonts land,
           so re-measure instead of trusting the first reading. */
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateDuration());
          this.resizeObserver.observe(this.copy);
        }

        document.fonts?.ready.then(() => this.updateDuration());
      }

      updateDuration() {
        const pixelsPerSecond = Math.max(1, parseFloat(this.dataset.speed) || 55);
        const width = this.copy.getBoundingClientRect().width;
        if (!width) return;

        const duration = (width / pixelsPerSecond).toFixed(2);
        if (duration === this.currentDuration) return;

        this.currentDuration = duration;
        this.style.setProperty('--marquee-duration', `${duration}s`);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
    }
  );
}
